var _rect, _rect2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCoachBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1486,
    height: 319,
    viewBox: "0 0 1486 319",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1486,
    height: 319,
    rx: 8,
    fill: "white",
    fillOpacity: 0.08
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1577_45591",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1486,
    height: 319
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1486,
    height: 319,
    rx: 8,
    fill: "white",
    fillOpacity: 0.08
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1577_45591)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -169,
    y: -749,
    width: 1829,
    height: 2588,
    fill: "url(#pattern0)",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.539,
    y: -74,
    width: 104,
    height: 104,
    rx: 8,
    transform: "rotate(45 131.539 -74)",
    fill: "url(#paint0_linear_1577_45591)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 422,
    y: 390.066,
    width: 104,
    height: 104,
    rx: 8,
    transform: "rotate(-120 422 390.066)",
    fill: "url(#paint1_linear_1577_45591)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1440.02,
    y: 372.836,
    width: 119.074,
    height: 119.074,
    rx: 8,
    transform: "rotate(-165 1440.02 372.836)",
    fill: "url(#paint2_linear_1577_45591)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1119.54,
    y: -51,
    width: 104,
    height: 104,
    rx: 8,
    transform: "rotate(45 1119.54 -51)",
    fill: "url(#paint3_linear_1577_45591)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1577_45591",
    transform: "scale(0.000403358 0.000285063)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1577_45591",
    x1: 165.453,
    y1: -40.7384,
    x2: 238.638,
    y2: 32.4472,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1577_45591",
    x1: 455.914,
    y1: 423.328,
    x2: 529.099,
    y2: 496.514,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1577_45591",
    x1: 1478.85,
    y1: 410.919,
    x2: 1562.64,
    y2: 494.712,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1577_45591",
    x1: 1153.45,
    y1: -17.7384,
    x2: 1226.64,
    y2: 55.4472,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoachBackground);
export default __webpack_public_path__ + "static/media/coachBackground.0bc6b1b6c21cedca1e27c3d5905f7e7b.svg";
export { ForwardRef as ReactComponent };